export enum AuthenticationStatusCode {
    Success = 0,
    RdsPending = 4000,
    AccessDenied = 4001,
    StepUpRequired = 4002,
    DeviceThrottled = 4003,
    TokenFamilyRevoked = 4004,
    ManualReview = 4005,
    FullLoginRequired = 4006,
    DisambiguationRequired = 4007,
    EmailOtpRequired = 4010,
    InvalidAccountSelection = 4012,
    EmailOtpMissingClientId = 4013,
    // The auth-bff's NoClientHubActivitySession status: the activity session behind the
    // browser's cookie no longer exists (deleted after 20 idle minutes).
    NoActivitySession = 16003
}
